var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.config.name,_vm._b({ref:"form",tag:"component",attrs:{"mode":_vm.mode},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},'component',_vm.config.props,false))}
var staticRenderFns = []

export { render, staticRenderFns }